
const En = ()=>import('../src/components/en')
const Home = ()=>import('../src/components/Home')
export default [
    {
        name: 'en',
        path: '/en',
        component: En
    },
    {
        name:'home',
        path:'/',
        component:Home
    }


]